import React from 'react'

import { Popover } from 'shared'
import { connect } from 'formik'

import itzLogo from './itz.svg'
import paydirektLogo from './paydirekt.svg'
import paypalLogo from './paypal.svg'
import sslLogo from './ssl_logo.png'
import { FormValues } from 'donate/types'
import { SSLLogoProps } from './types'

export const TrustLogos = () => (
  <div className="flex my-3 space-x-3 desktop:space-x-4">
    <img src={itzLogo} className="h-9" alt="" />
    <SSLLogo className="h-9" />
    <PaymentMethodLogo />
  </div>
)

export const SSLLogo = ({ className }: SSLLogoProps): JSX.Element => (
  <Popover
    trigger={<img src={sslLogo} className={className} alt="" />}
    i18nKey={'donate.trust_logos.ssl_popover'}
    popoverId="tooltip-for-ssl-logo"
  />
)

const PaymentMethodLogo = connect<{}, FormValues>(({ formik }) => {
  const paymentMethod = formik.values.payment_method
  let logo
  if (paymentMethod === 'paypal') {
    logo = paypalLogo
  } else if (paymentMethod === 'paydirekt') {
    logo = paydirektLogo
  }
  return logo ? <img src={logo} className="h-9" alt="" /> : null
})
